<script setup lang="ts">
import type { MonospaceWorkspace } from '#layers/data-model/public';
import type { LogoSize } from '#layers/ui/public';
import BrandLogo from '#layers/assets/components/BrandLogo.vue';

export interface WorkspaceLogoProps {
	workspace: MonospaceWorkspace;
	size?: LogoSize;
	class?: string;
}

const { class: className } = defineProps<WorkspaceLogoProps>();
</script>

<template>
	<BrandLogo :logo-id="workspace.logoId" :color="workspace.primaryColor" :size :class="className" />
</template>
